/* eslint-disable */
import throwAuthCouldNotFindFixtureByUsernameAndPasswordError from '../../../../Errors/Auth/AuthCouldNotFindFixtureByUsername..error';
import { usersFixture } from '../../../User/User.service.fixture';
import { authFixture } from '../../Auth.service.fixture';
import AuthAdapter from '../Auth.adapter';

/**
 * AuthMemoryAdapter
 * @class AuthMemoryAdapter
 * @implements {AuthServiceAdapterContract}
 * @extends {AuthAdapter}
 */
class AuthMemoryAdapter extends AuthAdapter {
  /**
   * How long the _token_'s should live
   * @type {number} The amount of time in milliseconds
   * @memberof AuthMemoryAdapter
   */
  _tokenDuration = 60 * 60 * 1000; // 60 minutes

  /**
   * Creates an instance of AuthMemoryAdapter
   * @param {AuthMemoryAdapterCreateDto} dto The params required to create an instance of `AuthMemoryAdapter`
   * @memberof AuthMemoryAdapter
   */
  constructor({ storageService }) {
    super({ storageService });
  }

  /**
   * Clears auth from storage. Does not log out the user.
   * @returns {void} void
   * @memberof AuthOktaAdapter
   */
  clearAuth = async () => {
    return;
  };

  /**
   * Ensure that the user is logged in and that they have a valid token that has not expired
   * @returns {Headers} The Headers with the included `Authorization` header.
   * @memberof AuthMemoryAdapter
   */
  createHeaders = () => {
    return {};
  };

  /**
   * Attempt to login a user with an `username` and a `password`
   * @param {AuthServiceLoginWithUsernameAndPasswordDto} dto The required params to login
   * @returns {Promise<AuthEntity>} The auth entity
   * @memberof AuthMemoryAdapter
   */
  loginWithUsernameAndPassword = async ({ password, username }) => {
    const foundUser = usersFixture.find((user) => user.username === username && user.password === password);
    if (foundUser === undefined) {
      return throwAuthCouldNotFindFixtureByUsernameAndPasswordError(username, password);
    }
    const newAuth = {
      ...authFixture,
      user: foundUser,
    };
    return this._changeState(newAuth);
  };

  /**
   * Logout a user
   * @returns {Promise<null>} The updated representation of the current user
   * @memberof AuthMemoryAdapter
   */
  logout = async () => {
    const newAuth = null;
    return this._changeState(newAuth);
  };

  /**
   * Refresh auth for a user
   * @returns {Promise<AuthEntity>} The updated representation of the current user
   * @memberof AuthMemoryAdapter
   */
  refreshAccessToken = async () => {
    const { user } = this._auth;
    const { username } = user;
    const foundUser = usersFixture.find((userFixture) => userFixture.username === username);
    if (foundUser === undefined) {
      return throwAuthCouldNotFindFixtureByUsernameAndPasswordError(username, ``);
    }
    /** @type {AuthEntity} */
    const newAuth = {
      ...authFixture,
      accessToken: {
        ...authFixture.accessToken,
        expiresAt: Date.now() + this._getTokenDuration(),
      },
      user: foundUser,
    };
    return this._changeState(newAuth);
  };
}

export default AuthMemoryAdapter;
